export const positionManagementRoute = {
    patterns: {
        positionManagement: '/position-management',
    },
} as const;
